__turbopack_context__.v({
  "EntityList": "slider-module-scss-module__egdOqa__EntityList",
  "EntityTileGrid": "slider-module-scss-module__egdOqa__EntityTileGrid",
  "Sports": "slider-module-scss-module__egdOqa__Sports",
  "arrowsTopAligned": "slider-module-scss-module__egdOqa__arrowsTopAligned",
  "darkTheme": "slider-module-scss-module__egdOqa__darkTheme",
  "imageStyles": "slider-module-scss-module__egdOqa__imageStyles",
  "skeleton": "slider-module-scss-module__egdOqa__skeleton",
  "skeletonImage": "slider-module-scss-module__egdOqa__skeletonImage",
  "skeletonPagination": "slider-module-scss-module__egdOqa__skeletonPagination",
  "skeletonPaginationPage": "slider-module-scss-module__egdOqa__skeletonPaginationPage",
  "skeletonSlide": "slider-module-scss-module__egdOqa__skeletonSlide",
  "skeletonText": "slider-module-scss-module__egdOqa__skeletonText",
  "slider": "slider-module-scss-module__egdOqa__slider",
  "sliderTrack": "slider-module-scss-module__egdOqa__sliderTrack",
});
